import { Box } from "@mui/material"
import React from "react"
import { useTranslation } from "react-i18next"
import Text from "src/components/Text"
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline"

const Warning = () => {
  const { t } = useTranslation()

  return (
    <Box
      maxWidth="468px"
      borderRadius="12px"
      bgcolor="#009BE066"
      p="18px"
      mb={3}
      display="flex"
    >
      <ErrorOutlineIcon />
      <Text ml={1}>
        {t(
          "Upgrading your locking period is irreversible. By upgrading your locking period, the new period end date will be the full term of the selected locking period.",
        )}
      </Text>
    </Box>
  )
}

export default Warning
